export const checkIfApproved = () => {
  return(dispatch, getState) => {
    const cart = getState().cart
    const approved = getState().shop.approved
    const approvedWarning = getState().shop.approvedWarning
    let quantity = 0
    cart.map(item => {
       return quantity += item.quantity
    })
    if (quantity > 1 && !approved) {
      dispatch({type: 'APPROVED'});
    } else if (quantity < 2 && approved) {
      dispatch({type: 'NOT_APPROVED'});
    }
    if (quantity > 2 && !approvedWarning) {
      dispatch({type: 'APPROVED_WARNING'});
    } else if (quantity < 3 && approvedWarning) {
      dispatch({type: 'NOT_APPROVED_WARNING'});
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/shop.js